import moment from 'moment';

export const getDeliveryDayDate = (selectedDate = moment()) => {
  // ✅ normalize input (string OR moment)
  const currentDate = moment.isMoment(selectedDate)
    ? selectedDate.clone()
    : moment(selectedDate, 'MM/DD/YYYY');

  const today = moment().format('MM/DD/YYYY');

  const isCurrentDateToday = currentDate.format('MM/DD/YYYY') === today;

  // ✅ avoid mutating currentDate
  const nextDate = currentDate.clone().add(1, 'days');

  const nextDateShort = nextDate.format('MMM DD');
  const nextDay = nextDate.format('dddd');

  return {
    day: isCurrentDateToday ? 'Tomorrow' : nextDay,
    date: nextDateShort,
    fullDate: nextDate.format('MM/DD/YYYY'),
    block: 'Second',
  };
};

export const generateDayDateMonth = (date, addMonth = true) => {
  const outputFormat = addMonth ? 'MMM DD dddd' : 'DD dddd';
  const momentDate = moment(date, 'MM/DD/YYYY');
  const isToday = momentDate.format('MM/DD/YYYY') === moment().format('MM/DD/YYYY');
  return `${isToday ? 'Today ' : ''}${momentDate.format(outputFormat)}`;
};
